{
  "actions": "Toiminnot",
  "hideButtonLabel": "Näytä vähemmän",
  "noTags": "Ei mitään",
  "showAllButtonLabel": "Näytä kaikki ({tagCount, number})"
}
